export const settingsEn: Record<string, string> = {
  'settings.fittingRooms.title': 'Fitting Rooms',
  'settings.fittingRooms.addPlaceholder': 'Enter room name...',
  'settings.fittingRooms.description': 'Manage your fitting rooms to organize appointments by location',
  'settings.fittingRooms.syncGoogleCalendar': 'Sync Google Calendar',
  'settings.fittingRooms.syncing': 'Syncing...',
  'settings.fittingRooms.roomName': 'Room Name',
  'settings.fittingRooms.addRoom': 'Add Room',
  'settings.fittingRooms.currentRooms': 'Current Fitting Rooms',
  'settings.fittingRooms.default': 'Default',
  'settings.fittingRooms.appointmentsCreated': '{count} appointments • Created {date}',
  'settings.fittingRooms.calendar': 'Calendar',
  'settings.fittingRooms.copied': 'Copied',
  'settings.fittingRooms.calendarCopied': 'Calendar ID copied to clipboard',
  'settings.fittingRooms.deleteTitle': 'Delete Fitting Room',
  'settings.fittingRooms.deleteConfirm': 'Are you sure you want to delete "{name}"? This action cannot be undone.',
  'settings.fittingRooms.cannotDeleteWithAppointments': 'Cannot delete room with {count} appointments',
  'settings.fittingRooms.noRooms': 'No fitting rooms created yet',
  'settings.fittingRooms.noRoomsDescription': 'Add your first room to get started',
  'settings.fittingRooms.noteLabel': 'Note',
  'settings.fittingRooms.noteDescription': 'The Default Room cannot be deleted. Other rooms can only be deleted if they have no appointments.',
  'settings.fittingRooms.error.load': 'Failed to load fitting rooms',
  'settings.fittingRooms.error.enterName': 'Please enter a room name',
  'settings.fittingRooms.error.create': 'Failed to create fitting room',
  'settings.fittingRooms.error.update': 'Failed to update fitting room',
  'settings.fittingRooms.error.delete': 'Failed to delete fitting room',
  'settings.fittingRooms.error.sync': 'Failed to sync calendar',
  'settings.fittingRooms.success.created': 'Fitting room created successfully',
  'settings.fittingRooms.success.updated': 'Fitting room updated successfully',
  'settings.fittingRooms.success.deleted': 'Fitting room deleted successfully',
  'settings.fittingRooms.success.sync': '{message}. Please check Google Calendar to verify the sync.',
  'settings.integrations.googleCalendar.title': 'Google Calendar',
  'settings.integrations.googleCalendar.status.connected': 'Connected',
  'settings.integrations.googleCalendar.status.disconnected': 'Disconnected',
  'settings.integrations.googleCalendar.resync': 'Re-sync All',
  'settings.integrations.error.enterWhatsAppToken': 'Please enter a WhatsApp API token',
  'settings.integrations.common.disconnect': 'Disconnect',
  'settings.integrations.google.workspace': 'Google Workspace',
  'settings.integrations.google.description': 'Connect Google account for calendar sync',
  'settings.integrations.google.connectedSuccess': 'Google Workspace connected successfully',
  'settings.integrations.google.connectError': 'Failed to connect Google Workspace',
  'settings.integrations.google.disconnectedSuccess': 'Google Workspace disconnected successfully',
  'settings.integrations.google.disconnectError': 'Failed to disconnect Google Workspace',
  'settings.integrations.google.syncSuccess': 'Calendar sync completed successfully',
  'settings.integrations.google.syncError': 'Failed to sync calendars',
  'settings.integrations.google.errorPrefix': 'Google integration error:',
  'settings.integrations.google.fixNow': 'Fix now',
  'settings.integrations.google.lastSynced': 'Last synced',
  'settings.integrations.google.never': 'Never',
  'settings.integrations.google.synced': 'Synced',
  'settings.integrations.google.pending': 'Pending',
  'settings.integrations.google.failed': 'Failed',
  'settings.integrations.google.total': 'Total',
  'settings.integrations.google.reauthorize': 'Re-authorize',
  'settings.integrations.google.disconnectTitle': 'Disconnect Google Workspace?',
  'settings.integrations.google.disconnectDescription': 'This will remove access to your Google account and stop syncing appointments and contacts.',
  'settings.integrations.google.connecting': 'Connecting...',
  'settings.integrations.google.connectAction': 'Connect Google Workspace',
  'settings.integrations.whatsapp.business': 'WhatsApp Business',
  'settings.integrations.whatsapp.description': 'Send appointment reminders and updates via WhatsApp',
  'settings.integrations.whatsapp.apiActive': 'API connection active',
  'settings.integrations.whatsapp.connectedSuccess': 'WhatsApp integration connected successfully',
  'settings.integrations.whatsapp.connectError': 'Failed to connect WhatsApp integration',
  'settings.integrations.whatsapp.disconnectedSuccess': 'WhatsApp integration disconnected successfully',
  'settings.integrations.whatsapp.disconnectError': 'Failed to disconnect WhatsApp integration',
  'settings.integrations.whatsapp.disconnectTitle': 'Disconnect WhatsApp?',
  'settings.integrations.whatsapp.disconnectDescription': 'This will remove your WhatsApp API token and stop sending messages through WhatsApp.',
  'settings.integrations.whatsapp.apiToken': 'API Token',
  'settings.integrations.whatsapp.apiTokenPlaceholder': 'Enter your WhatsApp Business API token',
  'settings.integrations.whatsapp.connecting': 'Connecting...',
  'settings.integrations.whatsapp.saveConnect': 'Save & Connect',
  'settings.integrations.googleCalendar.description': 'Sync appointments to room-specific Google Calendars',
  'settings.integrations.googleCalendar.active': 'Calendar sync active',
  'settings.integrations.googleCalendar.connectFirst': 'Connect Google Workspace first to enable calendar sync',
  'settings.integrations.stripe.title': 'Stripe Connect',
  'settings.integrations.stripe.description': 'Enable customer payments through Stripe',
  'settings.integrations.stripe.connectedTitle': 'Stripe connected',
  'settings.integrations.stripe.connectedDescription': 'Your Stripe Express account is ready.',
  'settings.integrations.stripe.connectError': 'Failed to connect Stripe',
  'settings.integrations.stripe.disconnectedSuccess': 'Stripe disconnected successfully',
  'settings.integrations.stripe.disconnectError': 'Failed to disconnect Stripe',
  'settings.integrations.stripe.account': 'Account',
  'settings.integrations.stripe.continueOnboarding': 'Continue onboarding',
  'settings.integrations.stripe.disconnectTitle': 'Disconnect Stripe?',
  'settings.integrations.stripe.disconnectDescription': 'This will disable payment processing for your organization. Customers will not be able to pay invoices or balances.',
  'settings.integrations.stripe.businessCountry': 'Business country',
  'settings.integrations.stripe.selectCountry': 'Select country',
  'settings.integrations.stripe.connecting': 'Connecting...',
  'settings.integrations.stripe.connectAction': 'Connect Stripe',

  // Supplier Management
  'supplier.list.title': 'Suppliers',
  'supplier.list.subtitle': 'Manage your suppliers and their pricing',
  'supplier.list.tableTitle': 'All Suppliers ({count})',
  'supplier.list.loading': 'Loading suppliers...',
  'supplier.list.error.title': 'Unable to load suppliers',
  'supplier.list.error.description': 'Please try again.',
  'supplier.list.empty.title': 'No suppliers found',
  'supplier.list.empty.searchDescription': 'Try adjusting your search terms.',
  'supplier.list.empty.defaultDescription': 'Get started by adding your first supplier.',
  'supplier.list.empty.addFirst': 'Add First Supplier',
  'supplier.list.filters.clear': 'Clear',
  'supplier.list.deleteConfirm': 'Are you sure you want to delete supplier \"{name}\"?',
  'supplier.form.leadTime': 'Lead Time (days)',
  'supplier.priceList.title': 'Price List',
  'supplier.performance.label': 'Performance',
  'supplier.form.name': 'Supplier Name',
  'supplier.form.contactEmail': 'Contact Email',
  'supplier.form.contactPhone': 'Contact Phone',
  'supplier.form.website': 'Website',
  'supplier.form.address': 'Address',
  'supplier.form.taxId': 'Tax ID',
  'supplier.form.notes': 'Notes',
  'supplier.actions.add': 'Add Supplier',
  'supplier.actions.edit': 'Edit Supplier',
  'supplier.actions.delete': 'Delete Supplier',
  'supplier.actions.view': 'View Details',
  'supplier.table.name': 'Name',
  'supplier.table.contact': 'Contact',
  'supplier.table.leadTime': 'Lead Time',
  'supplier.table.leadTimeValue': '{count} days',
  'supplier.table.products': '# Products',
  'supplier.table.performance': 'Performance',
  'supplier.table.actions': 'Actions',
  'supplier.pagination.previous': 'Previous',
  'supplier.pagination.next': 'Next',
  'supplier.pagination.page': 'Page {page} of {total}',
  'supplier.pricing.addPrice': 'Add Price',
  'supplier.pricing.saveChanges': 'Save Changes',
  'supplier.pricing.product': 'Product',
  'supplier.pricing.costPrice': 'Cost Price',
  'supplier.pricing.currency': 'Currency',
  'supplier.pricing.selectProduct': 'Select a product',
  'supplier.products.title': 'Supplied Products',
  'supplier.performance.onTimeDelivery': 'On-Time Delivery',
  'supplier.performance.qualityScore': 'Quality Score',
  'supplier.performance.responseTime': 'Response Time',
  'supplier.detail.tabs.profile': 'Profile',
  'supplier.detail.tabs.pricing': 'Price List',
  'supplier.detail.tabs.products': 'Products',
  'supplier.detail.tabs.performance': 'Performance',
  'supplier.messages.created': 'Supplier created successfully',
  'supplier.messages.updated': 'Supplier updated successfully',
  'supplier.messages.deleted': 'Supplier deleted successfully',
  'supplier.messages.error': 'Failed to load suppliers',
  'supplier.search.placeholder': 'Search suppliers...',
  'supplier.messages.productRemoved': 'Product removed from supplier',
  'supplier.messages.productRemoveError': 'Failed to remove product',
  'supplier.messages.loadProductsError': 'Failed to load supplier products',

  // Notifications
  'notifications.tab.unread': 'Unread',
  'notifications.tab.all': 'All',
  'notifications.empty.unread': "You're all caught up!",
  'notifications.empty.unread.description': 'No unread notifications at the moment.',
  'notifications.empty.all': 'No notifications yet',
  'notifications.empty.all.description': "You'll see important updates and alerts here.",
  'notifications.markAsRead': 'Mark as read',
  'notifications.viewAll': 'View All Notifications',
  'notifications.title': 'Notifications',
  'notifications.subtitle': 'Stay updated with important alerts and reminders',

  // Custom Fields Settings
  'settings.customFields.title': 'Custom Fields',
  'settings.customFields.description': 'Create custom fields that can be mapped to form submissions',
  'settings.customFields.addField': 'Add Custom Field',
  'settings.customFields.noFieldsYet': 'No custom fields yet',
  'settings.customFields.required': 'Required',
  'settings.customFields.key': 'Key',
  'settings.customFields.options': 'Options',
  'settings.customFields.deleteConfirm': 'Are you sure you want to delete "{name}"? This cannot be undone.',
  'settings.customFields.createTitle': 'Create Custom Field',
  'settings.customFields.editTitle': 'Edit Custom Field',
  'settings.customFields.fieldName': 'Field Name',
  'settings.customFields.fieldNamePlaceholder': 'e.g., Dream Wedding Description',
  'settings.customFields.fieldKey': 'Field Key',
  'settings.customFields.fieldKeyPlaceholder': 'e.g., dream_wedding_description',
  'settings.customFields.fieldKeyDescription': 'Used internally to store the data. Must be unique.',
  'settings.customFields.fieldKeyCannotChange': 'Field key cannot be changed after creation.',
  'settings.customFields.fieldType': 'Field Type',
  'settings.customFields.usedFor': 'Used For',
  'settings.customFields.type.text': 'Text',
  'settings.customFields.type.longText': 'Long Text',
  'settings.customFields.type.number': 'Number',
  'settings.customFields.type.date': 'Date',
  'settings.customFields.type.yesNo': 'Yes/No',
  'settings.customFields.type.dropdown': 'Dropdown',
  'settings.customFields.entity.leadsOnly': 'Leads Only',
  'settings.customFields.entity.customersOnly': 'Customers Only',
  'settings.customFields.entity.both': 'Both',
  'settings.customFields.addOption': 'Add option',
  'settings.customFields.requiredField': 'Required Field',
  'settings.customFields.requiredFieldDescription': 'Mark this field as required for form submissions',
  'settings.customFields.creating': 'Creating...',
  'settings.customFields.createField': 'Create Field',
  'settings.customFields.updating': 'Updating...',
  'settings.customFields.updateField': 'Update Field',

  // Stage Translations
  'settings.stages.previewAs': 'Preview labels as:',
  'settings.stages.editTranslations': 'Edit Stage Translations',
  'settings.stages.stage': 'Stage:',
  'settings.stages.label': '{locale} Label',
  'settings.stages.enterLabel': 'Enter {locale} label...',
  'settings.stages.characters': '{count}/100 characters',
  'settings.stages.preview': 'Preview',
  'settings.stages.noLabel': 'No label',
  'settings.stages.saveTranslation': 'Save {locale} Translation',
  'settings.stages.saveAllChanges': 'Save All Changes',
  'settings.stages.validationError': 'Validation Error',
  'settings.stages.labelLength': 'Label must be between 3 and 100 characters',
  'settings.stages.loadError': 'Failed to load translations',

  // Google Calendar Sync Modal
  'settings.sync.manageCalendarSync': 'Manage Calendar Sync',
  'settings.sync.title': 'Google Calendar Sync Management',

  // Notification Settings
  'settings.notifications.title': 'Notification Settings',
  'settings.notifications.description': 'Configure how you receive notifications from Sposa Suite',
  'settings.notifications.push.title': 'Push Notifications',
  'settings.notifications.push.description': 'Receive real-time notifications even when the app is closed',
  'settings.notifications.push.browser': 'Browser Push Notifications',
  'settings.notifications.push.browserDesc': 'Get notified about important updates instantly',
  'settings.notifications.push.notSupported': 'Not Supported',
  'settings.notifications.push.error': 'Error',
  'settings.notifications.push.active': 'Active',
  'settings.notifications.push.permissionGranted': 'Permission Granted',
  'settings.notifications.push.denied': 'Denied',
  'settings.notifications.push.notSet': 'Not Set',
  'settings.notifications.push.errorTitle': 'Push Notification Error',
  'settings.notifications.push.retrySubscription': 'Retry Subscription',
  'settings.notifications.push.testNotification': 'Test Notification',
  'settings.notifications.push.notSupportedMsg': 'Push notifications are not supported in this browser. Please use a modern browser like Chrome, Firefox, or Safari.',
  'settings.notifications.email.title': 'Email Notifications',
  'settings.notifications.email.description': 'Receive notifications via email',
  'settings.notifications.email.label': 'Email Notifications',
  'settings.notifications.email.desc': 'Get important updates sent to your email',
  'settings.notifications.types.title': 'Notification Types',
  'settings.notifications.types.description': 'Choose which types of notifications you want to receive',
  'settings.notifications.types.leadReminders': 'Lead Reminders',
  'settings.notifications.types.leadRemindersDesc': 'Follow-up reminders for leads',
  'settings.notifications.types.taskNotifications': 'Task Notifications',
  'settings.notifications.types.taskNotificationsDesc': 'Notifications for task assignments and updates',
  'settings.notifications.types.appointmentReminders': 'Appointment Reminders',
  'settings.notifications.types.appointmentRemindersDesc': 'Reminders for upcoming appointments',
  'settings.notifications.settingsUpdated': 'Settings Updated',
  'settings.notifications.settingsUpdatedDesc': 'Your notification preferences have been saved',
  'settings.notifications.saveError': 'Failed to save notification preferences',

  // Lead Rules
  'settings.leadRules.title': 'Lead Rules',
  'settings.leadRules.description': 'Manage automated follow-up rules for leads',
  'settings.leadRules.addRule': 'Add Rule',
  'settings.leadRules.createTitle': 'Create Lead Rule',
  'settings.leadRules.ruleName': 'Rule Name',
  'settings.leadRules.ruleNamePlaceholder': 'e.g., Follow up new inquiries',
  'settings.leadRules.triggerEvent': 'Trigger Event',
  'settings.leadRules.selectTrigger': 'Select trigger event',
  'settings.leadRules.triggerNewLead': 'New Lead',
  'settings.leadRules.triggerStageChange': 'Stage Change',
  'settings.leadRules.triggerNoActivity': 'No Activity',
  'settings.leadRules.triggerStage': 'Trigger Stage',
  'settings.leadRules.selectStage': 'Select stage',
  'settings.leadRules.delayMinutes': 'Delay (minutes)',
  'settings.leadRules.delayRange': '1-2880 minutes (48 hours max)',
  'settings.leadRules.action': 'Action',
  'settings.leadRules.selectAction': 'Select action',
  'settings.leadRules.actionEmail': 'Send Email (Coming)',
  'settings.leadRules.actionPush': 'Push Notification',
  'settings.leadRules.creating': 'Creating...',
  'settings.leadRules.createRule': 'Create Rule',
  'settings.leadRules.noRules': 'No lead rules configured',
  'settings.leadRules.noRulesDesc': 'Create your first rule to automate lead follow-ups',
  'settings.leadRules.table.name': 'Rule Name',
  'settings.leadRules.table.trigger': 'Trigger',
  'settings.leadRules.table.delay': 'Delay',
  'settings.leadRules.table.action': 'Action',
  'settings.leadRules.table.status': 'Status',
  'settings.leadRules.deleteTitle': 'Delete Lead Rule',
  'settings.leadRules.deleteConfirm': 'Are you sure you want to delete "{name}"? This action cannot be undone and will stop all future reminders from this rule.',
  'settings.leadRules.deleteRule': 'Delete Rule',
  'settings.leadRules.enabled': 'Enabled',
  'settings.leadRules.disabled': 'Disabled',
  'settings.leadRules.stageLabel': 'Stage: {name}',
  'settings.leadRules.success.created': 'Lead rule created successfully',
  'settings.leadRules.success.deleted': 'Rule deleted successfully',
  'settings.leadRules.success.toggled': 'Rule {status} successfully',
  'settings.leadRules.error.load': 'Failed to load lead rules',
  'settings.leadRules.error.create': 'Failed to create rule',
  'settings.leadRules.error.delete': 'Failed to delete rule',
  'settings.leadRules.error.update': 'Failed to update rule',
  'settings.leadRules.error.requiredFields': 'Please fill in all required fields',

  // Portal Auth
  'settings.portalAuth.title': 'Portal Authentication',
  'settings.portalAuth.description': 'Configure how customers sign in to your portal. Both methods provide secure, passwordless authentication.',
  'settings.portalAuth.otpEnabled': 'Enable Login Codes (OTP)',
  'settings.portalAuth.otpEnabledDesc': 'Allow customers to sign in using 6-digit codes sent to their email',
  'settings.portalAuth.otpInfo': 'Login codes are especially useful for PWA users who might have issues with magic links opening in external browsers.',
  'settings.portalAuth.smsEnabled': 'Enable SMS Codes',
  'settings.portalAuth.smsEnabledDesc': 'Allow customers to receive codes via SMS (requires phone numbers on file)',
  'settings.portalAuth.smsInfo': 'Configure your SMS provider below to enable SMS delivery for authentication codes.',
  'settings.portalAuth.smsProviderConfig': 'SMS Provider Configuration',
  'settings.portalAuth.smsProvider': 'SMS Provider',
  'settings.portalAuth.selectSmsProvider': 'Select SMS provider',
  'settings.portalAuth.senderId': 'Sender ID',
  'settings.portalAuth.senderIdPlaceholder': 'Your Organization Name',
  'settings.portalAuth.senderIdDesc': 'The name or number that appears as the sender of SMS messages.',
  'settings.portalAuth.twilioConfig': 'Twilio Configuration',
  'settings.portalAuth.accountSid': 'Account SID',
  'settings.portalAuth.authToken': 'Auth Token',
  'settings.portalAuth.apiKey': 'API Key',
  'settings.portalAuth.apiSecret': 'API Secret',
  'settings.portalAuth.emailTemplateSettings': 'Email Template Settings',
  'settings.portalAuth.emailSubject': 'Email Subject',
  'settings.portalAuth.emailTemplate': 'Email Template',
  'settings.portalAuth.availableVars': 'Available variables: {{orgName}}, {{code}}, {{customerName}}',
  'settings.portalAuth.customizeEmail': 'Customize the email content. Variables: {{orgName}}, {{code}}, {{customerName}}',
  'settings.portalAuth.saveChanges': 'Save Changes',
  'settings.portalAuth.saving': 'Saving...',
  'settings.portalAuth.resetToDefaults': 'Reset to Defaults',
  'settings.portalAuth.securityFeatures': 'Security Features:',
  'settings.portalAuth.securityExpiry': 'Codes expire in 10 minutes',
  'settings.portalAuth.securityRateLimit': 'Rate limited: 5 codes per hour, 20 per day',
  'settings.portalAuth.securityLockout': 'Account lockout after 5 failed attempts (15 min)',
  'settings.portalAuth.securitySession': 'Sessions last 180 days with auto-refresh',
  'settings.portalAuth.securityAudit': 'All events are logged for audit purposes',
  'settings.portalAuth.settingsSaved': 'Settings Saved',
  'settings.portalAuth.settingsSavedDesc': 'Portal authentication settings have been updated successfully.',
  'settings.portalAuth.loadError': 'Failed to load authentication settings',
  'settings.portalAuth.saveError': 'Failed to save authentication settings',

  // Branding
  'settings.branding.title': 'Portal Branding',
  'settings.branding.description': 'Customize how your customer portal appears to brides. Changes affect the installable app experience.',
  'settings.branding.preview': 'Preview',
  'settings.branding.portalShortName': 'Portal Short Name:',
  'settings.branding.browserTabIcon': 'Browser tab & app icon',
  'settings.branding.defaultLanguage': 'Default Language:',
  'settings.branding.shortNameLabel': 'Portal Short Name (Optional)',
  'settings.branding.shortNameDesc': 'Used for the app name on mobile devices. Leave empty to use organization name.',
  'settings.branding.brandColor': 'Brand Color',
  'settings.branding.brandColorDesc': 'Primary color used throughout the customer portal and PWA theme.',
  'settings.branding.defaultPortalLanguage': 'Default Portal Language',
  'settings.branding.defaultPortalLanguageDesc': "The default language customers see when they first visit the portal. They can change it using the language switcher.",
  'settings.branding.portalLogo': 'Portal Logo',
  'settings.branding.currentLogo': 'Current logo',
  'settings.branding.logoUsedIn': 'Used in portal header and welcome screens',
  'settings.branding.changeLogo': 'Change Logo',
  'settings.branding.chooseLogo': 'Choose Logo',
  'settings.branding.uploadLogoDesc': 'Upload your organization logo for the customer portal',
  'settings.branding.logoSizeHint': 'PNG, JPG up to 5MB. Recommended: 512×512px',
  'settings.branding.appIcon': 'App Icon / Favicon',
  'settings.branding.currentFavicon': 'Current favicon',
  'settings.branding.faviconUsedIn': 'Used in browser tabs and when installed as PWA',
  'settings.branding.changeIcon': 'Change Icon',
  'settings.branding.chooseIcon': 'Choose Icon',
  'settings.branding.uploadFaviconDesc': 'Upload a separate favicon/app icon (optional)',
  'settings.branding.faviconSizeHint': 'PNG, ICO up to 2MB. Recommended: 32×32px or 48×48px',
  'settings.branding.faviconFallback': 'If no icon is uploaded, the logo will be used as fallback for browser tabs and PWA installation.',
  'settings.branding.customerPortal': 'Customer Portal',
  'settings.branding.pwaReady': 'PWA Ready',
  'settings.branding.pwaReadyDesc': 'Customers can install your portal as an app on their phones',
  'settings.branding.saving': 'Saving...',
  'settings.branding.saveChanges': 'Save Changes',
  'settings.branding.settingsSaved': 'Settings saved',
  'settings.branding.settingsSavedDesc': 'Your branding settings have been updated successfully.',
  'settings.branding.loadError': 'Failed to load branding settings',
  'settings.branding.saveError': 'Failed to save branding settings',
  'settings.branding.invalidFile': 'Invalid file',
  'settings.branding.selectImage': 'Please select an image file',
  'settings.branding.fileTooLarge': 'File too large',
  'settings.branding.logoMaxSize': 'Please select an image smaller than 5MB',
  'settings.branding.faviconMaxSize': 'Please select an icon smaller than 2MB',
  'settings.branding.uploadFailed': 'Upload failed',
  'settings.branding.uploadFailedDesc': 'Failed to upload logo. Please try again.',
  'settings.branding.faviconUploadFailed': 'Failed to upload favicon. Please try again.',

  // Document Translations
  'settings.translations.title': 'Document Translations',
  'settings.translations.description': 'Manage translations for PDF documents in multiple languages',
  'settings.translations.bulkEdit': 'Bulk Edit',
  'settings.translations.newTranslation': 'New Translation',
  'settings.translations.saveChanges': 'Save Changes ({count})',
  'settings.translations.documentType': 'Document Type',
  'settings.translations.language': 'Language',
  'settings.translations.searchPlaceholder': 'Search translations...',
  'settings.translations.table.key': 'Translation Key',
  'settings.translations.table.value': 'Translation Value',
  'settings.translations.table.updated': 'Last Updated',
  'settings.translations.table.actions': 'Actions',
  'settings.translations.loading': 'Loading translations...',
  'settings.translations.noTranslations': 'No translations found for {docType} in {locale}',
  'settings.translations.editTitle': 'Edit Translation',
  'settings.translations.createTitle': 'Create Translation',
  'settings.translations.editorDescription': 'Create or modify translations for PDF documents.',
  'settings.translations.translationKey': 'Translation Key',
  'settings.translations.keyPlaceholder': 'e.g., PAYMENT_REQUEST_TITLE',
  'settings.translations.translationValue': 'Translation Value',
  'settings.translations.valuePlaceholder': 'Enter the translated text...',
  'settings.translations.saveTranslation': 'Save Translation',
  'settings.translations.docType.paymentRequest': 'Payment Request',
  'settings.translations.docType.invoice': 'Invoice',
  'settings.translations.docType.receipt': 'Receipt',
  'settings.translations.success.created': 'Translation created successfully',
  'settings.translations.success.updated': 'Translation updated successfully',
  'settings.translations.success.bulkUpdated': '{count} translations updated successfully',
  'settings.translations.error.load': 'Failed to load translations',
  'settings.translations.error.save': 'Failed to save translation',
  'settings.translations.error.bulkSave': 'Failed to bulk update translations',

  // Enhanced Content Editor
  'settings.contentEditor.editArticle': 'Edit Article',
  'settings.contentEditor.createArticle': 'Create Article',
  'settings.contentEditor.updateArticle': 'Update Article',
  'settings.contentEditor.description': 'Create and preview content with multiple formats',
  'settings.contentEditor.title': 'Title',
  'settings.contentEditor.titlePlaceholder': 'e.g., How to prepare for your fitting',
  'settings.contentEditor.urlSlug': 'URL Slug',
  'settings.contentEditor.slugPlaceholder': 'how-to-prepare-for-fitting',
  'settings.contentEditor.contentType': 'Content Type',
  'settings.contentEditor.selectType': 'Select type',
  'settings.contentEditor.category': 'Category',
  'settings.contentEditor.selectCategory': 'Select category',
  'settings.contentEditor.language': 'Language',
  'settings.contentEditor.selectLanguage': 'Select language',
  'settings.contentEditor.excerpt': 'Excerpt',
  'settings.contentEditor.excerptPlaceholder': 'Brief description',
  'settings.contentEditor.tags': 'Tags (comma-separated, optional)',
  'settings.contentEditor.tagsPlaceholder': 'fitting, preparation, undergarments',
  'settings.contentEditor.edit': 'Edit',
  'settings.contentEditor.previewTab': 'Preview',
  'settings.contentEditor.content': 'Content',
  'settings.contentEditor.contentPlaceholder': 'Enter your {type} content here...',
  'settings.contentEditor.htmlHint': 'Enter valid HTML. Content will be sanitized for security.',
  'settings.contentEditor.markdownHint': 'Use markdown syntax. Supports headings, lists, links, and more.',
  'settings.contentEditor.previewEmpty': 'Start typing in the edit tab to see your content preview here.',

  // Appointment Sync Manager
  'settings.syncManager.title': 'Appointment Sync',
  'settings.syncManager.description': 'Monitor and manage your Google Calendar synchronization',
  'settings.syncManager.healthy': 'Healthy',
  'settings.syncManager.syncing': 'Syncing',
  'settings.syncManager.needsAttention': 'Needs Attention',
  'settings.syncManager.successfullySynced': 'Successfully Synced',
  'settings.syncManager.pendingSync': 'Pending Sync',
  'settings.syncManager.failedSyncs': 'Failed Syncs',
  'settings.syncManager.totalProcessed': 'Total Processed',
  'settings.syncManager.last24h': 'Last 24h',
  'settings.syncManager.queue': 'Queue',
  'settings.syncManager.errors': 'Errors',
  'settings.syncManager.allTime': 'All time',
  'settings.syncManager.syncPerformance': 'Sync Performance',
  'settings.syncManager.excellent': 'Excellent',
  'settings.syncManager.good': 'Good',
  'settings.syncManager.fair': 'Fair',
  'settings.syncManager.poor': 'Poor',
  'settings.syncManager.successRate': 'Success Rate',
  'settings.syncManager.failureRate': 'Failure Rate',
  'settings.syncManager.realTimeMetrics': 'Real-time Metrics',
  'settings.syncManager.activeSyncs': 'Active Syncs',
  'settings.syncManager.avgTime': 'Avg Time',
  'settings.syncManager.queueSize': 'Queue Size',
  'settings.syncManager.systemStatus': 'System Status',
  'settings.syncManager.resyncing': 'Resyncing...',
  'settings.syncManager.resyncFailed': 'Resync Failed ({count})',
  'settings.syncManager.processing': 'Processing...',
  'settings.syncManager.processRetryQueue': 'Process Retry Queue',
  'settings.syncManager.queueManagement': 'Queue Management',
  'settings.syncManager.queueDescription': 'Advanced sync queue monitoring and controls',
  'settings.syncManager.pending': 'pending',
  'settings.syncManager.syncScheduleConfig': 'Sync Schedule Configuration',
  'settings.syncManager.syncScheduleDesc': 'Configure automatic sync intervals and notifications',
  'settings.syncManager.autoSync': 'Auto Sync',
  'settings.syncManager.autoSyncDesc': 'Automatically process sync queue at regular intervals',
  'settings.syncManager.syncInterval': 'Sync Interval (minutes)',
  'settings.syncManager.every5min': 'Every 5 minutes',
  'settings.syncManager.every15min': 'Every 15 minutes',
  'settings.syncManager.every30min': 'Every 30 minutes',
  'settings.syncManager.everyHour': 'Every hour',
  'settings.syncManager.every3hours': 'Every 3 hours',
  'settings.syncManager.syncNotifications': 'Sync Notifications',
  'settings.syncManager.syncNotificationsDesc': 'Get notified about sync failures and important events',
  'settings.syncManager.exportSyncData': 'Export Sync Data',
  'settings.syncManager.exportDesc': 'Export sync logs and statistics for analysis',
  'settings.syncManager.exportCsv': 'Export as CSV',
  'settings.syncManager.exportJson': 'Export as JSON',
  'settings.syncManager.exportIncludes': 'Export includes: operation type, status, timestamps, error messages, and retry counts',
  'settings.syncManager.overview': 'Overview',
  'settings.syncManager.queueItems': 'Queue Items',
  'settings.syncManager.analytics': 'Analytics',
  'settings.syncManager.health': 'Health',
  'settings.syncManager.queueProcessed': 'Queue processed',
  'settings.syncManager.queueProcessedDesc': 'Sync queue has been processed successfully.',
  'settings.syncManager.queueProcessFailed': 'Queue processing failed',
  'settings.syncManager.queueProcessFailedDesc': 'Failed to process sync queue. Please try again.',
  'settings.syncManager.retryQueued': 'Failed items queued for retry',
  'settings.syncManager.retryQueuedDesc': 'Failed sync items have been queued for retry.',
  'settings.syncManager.retryFailed': 'Retry failed',
  'settings.syncManager.retryFailedDesc': 'Failed to queue items for retry. Please try again.',
  'settings.syncManager.itemsCleared': 'Failed items cleared',
  'settings.syncManager.itemsClearedDesc': 'Failed sync items have been cleared from the queue.',
  'settings.syncManager.clearFailed': 'Clear failed',
  'settings.syncManager.clearFailedDesc': 'Failed to clear items. Please try again.',
  'settings.syncManager.exportCompleted': 'Export completed',
  'settings.syncManager.exportCompletedDesc': 'Sync logs exported as {format} file.',
  'settings.syncManager.exportFailed': 'Export failed',
  'settings.syncManager.exportFailedDesc': 'Failed to export sync logs. Please try again.',
  'settings.syncManager.scheduleUpdated': 'Sync schedule updated',
  'settings.syncManager.highFailureRate': 'High failure rate',
  'settings.syncManager.elevatedFailures': 'Elevated failures',
  'settings.syncManager.syncingInProgress': 'Syncing in progress',
  'settings.syncManager.allOperational': 'All systems operational',

  // Billing
  'settings.billing.paymentSettings': 'Payment Settings',
  'settings.billing.paymentSettingsDesc': 'Configure payment options for your customer portal',
  'settings.billing.minPaymentLabel': 'Minimum Payment Amount (€)',
  'settings.billing.minPaymentDesc': 'The minimum amount customers can pay when making payments through the customer portal',
  'settings.billing.minPaymentUpdated': 'Minimum payment amount updated successfully',
  'settings.billing.minPaymentError': 'Failed to update minimum payment amount',
  'settings.billing.invalidAmount': 'Invalid Amount',
  'settings.billing.minAmountError': 'Minimum payment amount must be at least €0.01',
  'settings.billing.currentPlan': 'Current Plan',
  'settings.billing.seatsUsed': 'Seats Used',
  'settings.billing.additionalSeats': 'Additional seats will be billed at your next invoice.',
  'settings.billing.nextBilling': 'Next billing:',
  'settings.billing.managementTitle': 'Billing Management',
  'settings.billing.managementDesc': 'Update payment methods, download invoices, and manage your subscription',
  'settings.billing.manageSubscription': 'Manage Subscription',
  'settings.billing.openingPortal': 'Opening Portal...',
  'settings.billing.portalError': 'Failed to open billing portal',
  'settings.billing.paymentFailed': 'Your last payment failed. Please update your payment method to avoid service interruption.',
  'settings.billing.retryPayment': 'Retry Payment',
  'settings.billing.seatOverage': "You're using {used} seats but only have {allowed} in your plan.",
  'settings.billing.upgradePlan': 'Upgrade Plan',
  'settings.billing.planFeatures': 'Plan Features',
  'settings.billing.planFeaturesDesc': 'Everything included in your {plan} plan',
  'settings.billing.feature.paymentMethods': 'Update payment methods',
  'settings.billing.feature.invoices': 'Download invoices',
  'settings.billing.feature.changePlan': 'Change or cancel plan',
  'settings.billing.feature.billingAddress': 'Update billing address',
  'settings.billing.feature.teamManagement': 'Team Management',
  'settings.billing.feature.teamMembers': 'Up to {count} team members',
  'settings.billing.feature.scheduling': 'Advanced Scheduling',
  'settings.billing.feature.schedulingDesc': 'Calendar sync and automated reminders',
  'settings.billing.feature.support': 'Priority Support',
  'settings.billing.feature.supportDesc': '24/7 email and chat support',

  // Business Hours
  'settings.businessHours.title': 'Business Hours',
  'settings.businessHours.holidaysTitle': 'Holidays & Closures',
  'settings.businessHours.date': 'Date *',
  'settings.businessHours.name': 'Name *',
  'settings.businessHours.namePlaceholder': 'e.g., Christmas Day',
  'settings.businessHours.addHoliday': 'Add Holiday',
  'settings.businessHours.description': 'Description',
  'settings.businessHours.descriptionPlaceholder': 'Optional description',
  'settings.businessHours.upcomingHolidays': 'Upcoming Holidays',
  'settings.businessHours.noHolidays': 'No holidays configured',
  'settings.businessHours.remove': 'Remove',
  'settings.businessHours.to': 'to',
  'settings.businessHours.closed': 'Closed',
  'settings.businessHours.break': 'Break: {start} - {end}',
  'settings.businessHours.addBreak': 'Add Break',
  'settings.businessHours.day.sunday': 'Sunday',
  'settings.businessHours.day.monday': 'Monday',
  'settings.businessHours.day.tuesday': 'Tuesday',
  'settings.businessHours.day.wednesday': 'Wednesday',
  'settings.businessHours.day.thursday': 'Thursday',
  'settings.businessHours.day.friday': 'Friday',
  'settings.businessHours.day.saturday': 'Saturday',
  'settings.businessHours.updated': 'Business hours updated',
  'settings.businessHours.updateError': 'Failed to update business hours',
  'settings.businessHours.fetchError': 'Failed to fetch business hours',
  'settings.businessHours.holidayAdded': 'Holiday added successfully',
  'settings.businessHours.holidayAddError': 'Failed to add holiday',
  'settings.businessHours.holidayDeleted': 'Holiday deleted successfully',
  'settings.businessHours.holidayDeleteError': 'Failed to delete holiday',
  'settings.businessHours.breakAdded': 'Break added successfully',
  'settings.businessHours.breakAddError': 'Failed to add break',
  'settings.businessHours.breakDeleted': 'Break deleted successfully',
  'settings.businessHours.breakDeleteError': 'Failed to delete break',
  'settings.businessHours.breakTimesError': 'Please fill in start and end times',
  'settings.businessHours.breakClosedDayError': 'Cannot add break to closed day',
  'settings.businessHours.breakOutsideHoursError': 'Break must be within business hours ({open} - {close})',
  'settings.businessHours.requiredFieldsError': 'Please fill in required fields',

  // Templates Panel
  'settings.templates.title': 'Message Templates',
  'settings.templates.description': 'Manage email, SMS, Magic Link, User Invitation, and Payment Confirmation templates with dynamic content',
  'settings.templates.language': 'Language:',
  'settings.templates.locale.enUS': 'English (US)',
  'settings.templates.locale.esES': 'Spanish (Spain)',
  'settings.templates.locale.frFR': 'French (France)',
  'settings.templates.locale.deDE': 'German (Germany)',
  'settings.templates.locale.itIT': 'Italian (Italy)',
  'settings.templates.newTemplate': 'New Template',
  'settings.templates.table.name': 'Name',
  'settings.templates.table.channel': 'Channel',
  'settings.templates.table.language': 'Language',
  'settings.templates.table.subject': 'Subject/Preview',
  'settings.templates.table.lastEdited': 'Last Edited',
  'settings.templates.table.actions': 'Actions',
  'settings.templates.loading': 'Loading templates...',
  'settings.templates.noTemplates': 'No templates found for {locale}',
  'settings.templates.system': 'System',
  'settings.templates.systemCannotEdit': 'System templates cannot be edited directly',
  'settings.templates.editTemplate': 'Edit template',
  'settings.templates.testWith': 'Test with...',
  'settings.templates.channelMagicLink': 'MAGIC LINK',
  'settings.templates.channelUserInvitation': 'USER INVITATION',
  'settings.templates.channelPasswordReset': 'PASSWORD RESET',
  'settings.templates.channelPayment': 'PAYMENT',
  'settings.templates.editTitle': 'Edit Template',
  'settings.templates.createTitle': 'Create Template',
  'settings.templates.editorDescription': 'Create dynamic templates using Handlebars variables for personalized messages.',
  'settings.templates.templateName': 'Template Name',
  'settings.templates.templateNamePlaceholder': 'e.g., Appointment Reminder',
  'settings.templates.channel': 'Channel',
  'settings.templates.channelEmail': 'Email',
  'settings.templates.channelSms': 'SMS',
  'settings.templates.channelPaymentConfirmation': 'Payment Confirmation',
  'settings.templates.subjectLine': 'Subject Line',
  'settings.templates.subjectPlaceholder': 'e.g., Your appointment with {{organization.name}}',
  'settings.templates.messageContent': 'Message Content',
  'settings.templates.code': 'Code',
  'settings.templates.preview': 'Preview',
  'settings.templates.contentPlaceholder': 'Enter your message content with variables like {{customer.first_name}}',
  'settings.templates.availableVariables': 'Available Variables',
  'settings.templates.noContentPreview': 'No content to preview',
  'settings.templates.cancel': 'Cancel',
  'settings.templates.updateTemplate': 'Update Template',
  'settings.templates.createTemplate': 'Create Template',
  'settings.templates.success.updated': 'Template updated successfully',
  'settings.templates.success.created': 'Template created successfully',
  'settings.templates.error.load': 'Failed to load templates',
  'settings.templates.error.save': 'Failed to {action} template',
  'settings.templates.error.selectCustomer': 'Please select a customer for testing',
  'settings.templates.success.testSent': 'Test {type} sent successfully',
  'settings.templates.error.testSend': 'Failed to send test message',

  // Task Templates Panel
  'settings.taskTemplates.title': 'Task Templates',
  'settings.taskTemplates.description': 'Configure automatic task generation templates for leads and customers',
  'settings.taskTemplates.leadTasks': 'Lead Tasks',
  'settings.taskTemplates.customerTasks': 'Customer Tasks',
  'settings.taskTemplates.populateExamples': 'Populate Examples',
  'settings.taskTemplates.addTemplate': 'Add Template',
  'settings.taskTemplates.searchPlaceholder': 'Search templates...',
  'settings.taskTemplates.noTemplates': 'No task templates found',
  'settings.taskTemplates.changeSearch': 'Try changing your search query',
  'settings.taskTemplates.disabled': 'Disabled',
  'settings.taskTemplates.titleTemplate': 'Title Template',
  'settings.taskTemplates.dueOffset': 'Due Offset',
  'settings.taskTemplates.descriptionLabel': 'Description',
  'settings.taskTemplates.createNew': 'Create New',
  'settings.taskTemplates.editLabel': 'Edit',
  'settings.taskTemplates.dialogTitle': '{mode} Task Template',
  'settings.taskTemplates.dialogDescription': 'Configure when and how tasks should be automatically generated',
  'settings.taskTemplates.templateName': 'Template Name',
  'settings.taskTemplates.templateNamePlaceholder': "E.g., 'New Lead Follow-up'",
  'settings.taskTemplates.entityType': 'Entity Type',
  'settings.taskTemplates.selectEntity': 'Select entity type',
  'settings.taskTemplates.entityLead': 'Lead',
  'settings.taskTemplates.entityCustomer': 'Customer',
  'settings.taskTemplates.triggerEvent': 'Trigger Event',
  'settings.taskTemplates.selectTrigger': 'Select trigger event',
  'settings.taskTemplates.leadCreated': 'Lead Created',
  'settings.taskTemplates.stagePrefix': 'Stage: {name}',
  'settings.taskTemplates.milestoneDepositPaid': 'Milestone: Deposit Paid',
  'settings.taskTemplates.milestoneOrderPlaced': 'Milestone: Order Placed',
  'settings.taskTemplates.milestoneFirstFitting': 'Milestone: First Fitting Scheduled',
  'settings.taskTemplates.milestoneDelivery': 'Milestone: Delivery Due',
  'settings.taskTemplates.milestonePostSale': 'Milestone: Post-Sale Follow-up',
  'settings.taskTemplates.dueOffsetLabel': 'Due Offset',
  'settings.taskTemplates.selectTimeOffset': 'Select time offset',
  'settings.taskTemplates.offset.5m': '5 minutes',
  'settings.taskTemplates.offset.10m': '10 minutes',
  'settings.taskTemplates.offset.30m': '30 minutes',
  'settings.taskTemplates.offset.1h': '1 hour',
  'settings.taskTemplates.offset.4h': '4 hours',
  'settings.taskTemplates.offset.8h': '8 hours',
  'settings.taskTemplates.offset.1d': '1 day',
  'settings.taskTemplates.offset.2d': '2 days',
  'settings.taskTemplates.offset.3d': '3 days',
  'settings.taskTemplates.offset.1w': '1 week',
  'settings.taskTemplates.offset.30d': '30 days',
  'settings.taskTemplates.taskTitleTemplate': 'Task Title Template',
  'settings.taskTemplates.taskTitlePlaceholder': "E.g., 'Follow up with {{name}}'",
  'settings.taskTemplates.descTemplate': 'Description Template (Optional)',
  'settings.taskTemplates.descTemplatePlaceholder': "E.g., 'Check if {{name}} has any questions about their inquiry'",
  'settings.taskTemplates.pushNotifications': 'Push Notifications',
  'settings.taskTemplates.emailNotifications': 'Email Notifications',
  'settings.taskTemplates.templateEnabled': 'Template Enabled',
  'settings.taskTemplates.cancel': 'Cancel',
  'settings.taskTemplates.create': 'Create',
  'settings.taskTemplates.update': 'Update',
  'settings.taskTemplates.deleteTitle': 'Delete Template',
  'settings.taskTemplates.deleteConfirm': 'Are you sure you want to delete the template "{name}"? This action cannot be undone.',
  'settings.taskTemplates.deleteTemplate': 'Delete Template',
  'settings.taskTemplates.validationError': 'Validation Error',
  'settings.taskTemplates.validationMessage': 'Please fill in all required fields',
  'settings.taskTemplates.success.created': 'Task template created successfully',
  'settings.taskTemplates.success.updated': 'Task template updated successfully',
  'settings.taskTemplates.success.deleted': 'Task template deleted successfully',
  'settings.taskTemplates.success.toggled': 'Template {status} successfully',
  'settings.taskTemplates.success.populated': '{count} task templates added successfully',
  'settings.taskTemplates.error.load': 'Failed to load task templates',
  'settings.taskTemplates.error.save': 'Failed to save task template',
  'settings.taskTemplates.error.delete': 'Failed to delete task template',
  'settings.taskTemplates.error.toggle': 'Failed to update template status',
  'settings.taskTemplates.error.populate': 'Failed to populate task templates',

  // Portal Content Panel
  'settings.portalContent.title': 'Portal Content',
  'settings.portalContent.description': 'Manage FAQ articles and help content for your customer portal',
  'settings.portalContent.newArticle': 'New Article',
  'settings.portalContent.allArticles': 'All Articles ({count})',
  'settings.portalContent.published': 'Published ({count})',
  'settings.portalContent.drafts': 'Drafts ({count})',
  'settings.portalContent.publishedArticles': 'Published Articles',
  'settings.portalContent.publishedDescription': 'Drag and drop to reorder how articles appear in the customer portal',
  'settings.portalContent.publishedBadge': 'Published',
  'settings.portalContent.table.title': 'Title',
  'settings.portalContent.table.category': 'Category',
  'settings.portalContent.table.language': 'Language',
  'settings.portalContent.table.status': 'Status',
  'settings.portalContent.table.updatedAt': 'Updated At',
  'settings.portalContent.table.actions': 'Actions',
  'settings.portalContent.loading': 'Loading articles...',
  'settings.portalContent.noArticles': 'No articles found',
  'settings.portalContent.uncategorized': 'Uncategorized',
  'settings.portalContent.edit': 'Edit',
  'settings.portalContent.unpublish': 'Unpublish',
  'settings.portalContent.publish': 'Publish',
  'settings.portalContent.delete': 'Delete',
  'settings.portalContent.success.updated': 'Article updated successfully',
  'settings.portalContent.success.created': 'Article created successfully',
  'settings.portalContent.success.published': 'Article published successfully',
  'settings.portalContent.success.unpublished': 'Article unpublished successfully',
  'settings.portalContent.success.deleted': 'Article deleted successfully',
  'settings.portalContent.error.load': 'Failed to load articles',
  'settings.portalContent.error.save': 'Failed to {action} article',
  'settings.portalContent.error.status': 'Failed to update article status',
  'settings.portalContent.error.delete': 'Failed to delete article',
  'settings.portalContent.error.reorder': 'Failed to reorder articles',

  // Appointment Sync Manager (additional keys)
  'settings.syncManager.completed': 'Completed',
  'settings.syncManager.failed': 'Failed',
  'settings.syncManager.processQueue': 'Process Queue ({count})',
  'settings.syncManager.failedItems': 'Failed Items ({count})',
  'settings.syncManager.retryAllFailed': 'Retry All Failed',
  'settings.syncManager.clearAllFailed': 'Clear All Failed',
  'settings.syncManager.avgProcessingTime': 'Average Processing Time',
  'settings.syncManager.searchQueueItems': 'Search queue items...',
  'settings.syncManager.status': 'Status',
  'settings.syncManager.allStatus': 'All Status',
  'settings.syncManager.operation': 'Operation',
  'settings.syncManager.allOperations': 'All Operations',
  'settings.syncManager.create': 'Create',
  'settings.syncManager.updateOp': 'Update',
  'settings.syncManager.deleteOp': 'Delete',
  'settings.syncManager.resync': 'Resync',
  'settings.syncManager.itemsSelected': '{count} item(s) selected',
  'settings.syncManager.clear': 'Clear',
  'settings.syncManager.retrySelected': 'Retry Selected',
  'settings.syncManager.removeSelected': 'Remove Selected',
  'settings.syncManager.noQueueItems': 'No queue items found',
  'settings.syncManager.adjustFilters': 'Try adjusting your search or filters',
  'settings.syncManager.showingItems': 'Showing {count} items',
  'settings.syncManager.selectAllVisible': 'Select All Visible',
  'settings.syncManager.retries': '{count} retries',
  'settings.syncManager.viewDetails': 'View Details',
  'settings.syncManager.processingTimeTrends': 'Processing Time Trends',
  'settings.syncManager.chartComingSoon': 'Chart coming soon',
  'settings.syncManager.errorRateAnalysis': 'Error Rate Analysis',
  'settings.syncManager.queueHealthIndicators': 'Queue Health Indicators',
  'settings.syncManager.errorRate': 'Error Rate',
  'settings.syncManager.avgProcessing': 'Avg Processing',
  'settings.syncManager.queueLoad': 'Queue Load',
  'settings.syncManager.light': 'Light',
  'settings.syncManager.moderate': 'Moderate',
  'settings.syncManager.heavy': 'Heavy',
  'settings.syncManager.systemHealthDashboard': 'System Health Dashboard',
  'settings.syncManager.alertsEnabled': 'Alerts enabled',
  'settings.syncManager.alertsDisabled': 'Alerts disabled',
  'settings.syncManager.connectionQuality': 'Connection Quality',
  'settings.syncManager.stable': 'stable',
  'settings.syncManager.unstable': 'unstable',
  'settings.syncManager.poor2': 'poor',
  'settings.syncManager.idle': 'idle',
  'settings.syncManager.allOperational2': 'All systems operational',
  'settings.syncManager.someIssues': 'Some issues detected',
  'settings.syncManager.multipleFailures': 'Multiple failures detected',
  'settings.syncManager.noRecentActivity': 'No recent activity',
  'settings.syncManager.itemsInQueue': '{count} items in queue',
  'settings.syncManager.processingSpeed': 'Processing Speed',
  'settings.syncManager.fast': 'Fast',
  'settings.syncManager.slow': 'Slow',
  'settings.syncManager.avgSeconds': '~{count}s avg',
  'settings.syncManager.healthAlerts': 'Health Alerts & Recommendations',
  'settings.syncManager.highFailureDetected': 'High Failure Rate Detected',
  'settings.syncManager.highFailureDesc': '{count} failed items require attention. Consider checking Google Calendar connection.',
  'settings.syncManager.queueBacklog': 'Queue Backlog Warning',
  'settings.syncManager.queueBacklogDesc': 'Large queue detected ({count} items). Consider processing queue or reducing sync frequency.',
  'settings.syncManager.slowProcessing': 'Slow Processing Performance',
  'settings.syncManager.slowProcessingDesc': 'Average processing time is {count}s. Consider checking network connectivity.',
  'settings.syncManager.allHealthy': 'All Systems Healthy',
  'settings.syncManager.allHealthyDesc': 'Sync system is operating optimally with no issues detected.',
  'settings.syncManager.quickActions': 'Quick Actions',
  'settings.syncManager.configureSchedule': 'Configure Schedule',
  'settings.syncManager.exportReports': 'Export Reports',
  'settings.syncManager.clearFailedTitle': 'Clear Failed Items?',
  'settings.syncManager.clearFailedConfirmDesc': 'This will remove {count} failed items from the queue. This action cannot be undone.',
  'settings.syncManager.clearFailedItems': 'Clear Failed Items',
  'settings.syncManager.legacySync': 'Legacy Sync (v1)',
  'settings.syncManager.legacySyncDesc': 'Synchronize appointments from the legacy system',
  'settings.syncManager.syncingV1': 'Syncing v1 Appointments...',
  'settings.syncManager.resyncAllV1': 'Resync All v1 Appointments',
  'settings.syncManager.saveChanges': 'Save Changes',

  // Organisation Panel
  'settings.org.title': 'Organization Details',
  'settings.org.description': "Configure your organization's basic information and branding",
  'settings.org.loadError': 'Failed to load organization settings',
  'settings.org.saveSuccess': 'Organization settings updated successfully',
  'settings.org.saveError': 'Failed to save organization settings',
  'settings.org.orgName': 'Organization Name',
  'settings.org.orgNamePlaceholder': 'Enter organization name',
  'settings.org.streetAddress': 'Street Address',
  'settings.org.streetAddressPlaceholder': 'Via Piave, 15',
  'settings.org.city': 'City',
  'settings.org.cityPlaceholder': 'Varese',
  'settings.org.province': 'Province',
  'settings.org.provincePlaceholder': 'VA',
  'settings.org.phone': 'Phone',
  'settings.org.phonePlaceholder': '+39 0332 123456',
  'settings.org.fax': 'Fax (Optional)',
  'settings.org.faxPlaceholder': '+39 0332 123457',
  'settings.org.vatId': 'VAT ID (Partita IVA)',
  'settings.org.vatIdPlaceholder': 'IT12345678901',
  'settings.org.taxId': 'Tax ID (Codice Fiscale)',
  'settings.org.taxIdPlaceholder': '12345678901',
  'settings.org.defaultLocale': 'Default Locale',
  'settings.org.selectLocale': 'Select locale',
  'settings.org.timezone': 'Timezone',
  'settings.org.timezoneRegion.utc': 'UTC',
  'settings.org.timezoneRegion.africa': 'Africa',
  'settings.org.timezoneRegion.americas': 'Americas',
  'settings.org.timezoneRegion.asia': 'Asia',
  'settings.org.timezoneRegion.europe': 'Europe',
  'settings.org.timezoneRegion.oceania': 'Oceania',
  'settings.org.selectTimezone': 'Select timezone...',
  'settings.org.searchTimezone': 'Search timezone...',
  'settings.org.noTimezoneFound': 'No timezone found.',
  'settings.org.logo': 'Organization Logo',
  'settings.org.logoAlt': 'Organization logo',
  'settings.org.upload': 'Upload',
  'settings.org.remove': 'Remove',
  'settings.org.logoHint': 'PNG or JPG, max 1MB, 512×512px recommended',
  'settings.org.logoSizeError': 'Logo file size must be less than 1MB',
  'settings.org.logoFormatError': 'Please upload a PNG or JPG file',
  'settings.org.logoDimensionsError': 'Logo dimensions must be 512×512 pixels or smaller',
  'settings.org.logoUploadSuccess': 'Logo uploaded successfully',
  'settings.org.logoUploadError': 'Failed to upload logo',
  'settings.org.invalidImageError': 'Invalid image file',
  'settings.org.saveChanges': 'Save Changes',

  // Stages Panel
  'settings.stagesPanel.workflowTitle': 'Workflow Stages',
  'settings.stagesPanel.workflowDescription': 'Configure stages for your lead and alteration management workflows',
  'settings.stagesPanel.leadStages': 'Lead Stages',
  'settings.stagesPanel.alterationStages': 'Alteration Stages',
  'settings.stagesPanel.addStage': 'Add Stage',
  'settings.stagesPanel.lead': 'Lead',
  'settings.stagesPanel.alteration': 'Alteration',
  'settings.stagesPanel.addNewStage': 'Add New {type} Stage',
  'settings.stagesPanel.createDescription': 'Create a new stage for your {type} workflow',
  'settings.stagesPanel.stageName': 'Stage Name',
  'settings.stagesPanel.stageNamePlaceholder': 'Enter stage name',
  'settings.stagesPanel.color': 'Color',
  'settings.stagesPanel.loadError': 'Failed to load stages',
  'settings.stagesPanel.addSuccess': '{type} stage added successfully',
  'settings.stagesPanel.addError': 'Failed to add stage',
  'settings.stagesPanel.reorderSuccess': 'Stage order updated successfully',
  'settings.stagesPanel.reorderError': 'Failed to update stage order',
  'settings.stagesPanel.deleteStage': 'Delete Stage',
  'settings.stagesPanel.deleteError': 'Failed to Delete Stage',
  'settings.stagesPanel.cannotDelete': 'Cannot Delete Stage',
  'settings.stagesPanel.selectDestination': 'Please select a destination stage for the {count} {type} before deleting.',
  'settings.stagesPanel.leads': 'leads',
  'settings.stagesPanel.tasks': 'tasks',
  'settings.stagesPanel.showOnKanban': 'Show on Kanban',
  'settings.stagesPanel.visibilitySuccess': 'Stage {status} on Kanban board',
  'settings.stagesPanel.enabled': 'enabled',
  'settings.stagesPanel.disabled': 'disabled',
  'settings.stagesPanel.visibilityError': 'Failed to update stage visibility',
  'settings.stagesPanel.noStages': 'No {type} stages configured yet',
  'settings.stagesPanel.containsActiveItems': 'Stage Contains Active Items',
  'settings.stagesPanel.moveTo': 'Move {type} to:',
  'settings.stagesPanel.emptyStage': 'This stage is empty and can be safely deleted.',
  'settings.stagesPanel.moveAndDelete': 'Move {count} Items & Delete',

  // Users & Roles Panel
  'settings.users.title': 'Users & Roles Management',
  'settings.users.description': 'Manage team members, permissions, and role assignments',
  'settings.users.loadError': 'Failed to load users and roles data',
  'settings.users.usersTab': 'Users',
  'settings.users.rolesTab': 'Roles',
  'settings.users.invitationsTab': 'Pending Invitations',
  'settings.users.teamMembers': 'Team Members',
  'settings.users.inviteUser': 'Invite User',
  'settings.users.inviteNewUser': 'Invite New User',
  'settings.users.inviteDescription': 'Send an invitation to a new team member',
  'settings.users.firstName': 'First Name',
  'settings.users.firstNamePlaceholder': 'Enter first name',
  'settings.users.lastName': 'Last Name',
  'settings.users.lastNamePlaceholder': 'Enter last name',
  'settings.users.emailAddress': 'Email Address',
  'settings.users.emailPlaceholder': 'Enter email address',
  'settings.users.role': 'Role',
  'settings.users.selectRole': 'Select a role',
  'settings.users.sending': 'Sending...',
  'settings.users.sendInvitation': 'Send Invitation',
  'settings.users.userExists': 'User already exists',
  'settings.users.userExistsDesc': 'A user with this email address already exists in your organization',
  'settings.users.invitationCreated': 'Invitation Created',
  'settings.users.invitationCreatedEmailFailed': 'Invitation created but email sending failed. You need to configure the RESEND_API_KEY secret in your Supabase project.',
  'settings.users.invitationSent': 'User invitation sent successfully',
  'settings.users.invitationError': 'Failed to send invitation',
  'settings.users.2faToggled': '2FA {status} successfully',
  'settings.users.enabled': 'enabled',
  'settings.users.disabled': 'disabled',
  'settings.users.2faError': 'Failed to update 2FA setting',
  'settings.users.passwordResetSent': 'Password reset email sent successfully',
  'settings.users.passwordResetError': 'Failed to send password reset email',
  'settings.users.userDisabled': 'User disabled successfully',
  'settings.users.disableError': 'Failed to disable user',
  'settings.users.userEnabled': 'User enabled successfully',
  'settings.users.enableError': 'Failed to enable user',
  'settings.users.impersonateSuccess': 'Impersonation session started in new tab',
  'settings.users.impersonateError': 'Failed to start impersonation session',
  'settings.users.userUpdated': 'User details updated successfully',
  'settings.users.userUpdateError': 'Failed to update user details',
  'settings.users.roleSaved': 'Role {action} successfully',
  'settings.users.updated': 'updated',
  'settings.users.created': 'created',
  'settings.users.roleSaveError': 'Failed to save role',
  'settings.users.table.name': 'Name',
  'settings.users.table.email': 'Email',
  'settings.users.table.role': 'Role',
  'settings.users.table.status': 'Status',
  'settings.users.table.lastLogin': 'Last Login',
  'settings.users.table.sent': 'Sent',
  'settings.users.table.expires': 'Expires',
  'settings.users.table.actions': 'Actions',
  'settings.users.noRole': 'No Role',
  'settings.users.active': 'Active',
  'settings.users.inactive': 'Inactive',
  'settings.users.never': 'Never',
  'settings.users.resetPassword': 'Reset Password',
  'settings.users.impersonateUser': 'Impersonate User (soon)',
  'settings.users.editDetails': 'Edit Details',
  'settings.users.disableUser': 'Disable User',
  'settings.users.enableUser': 'Enable User',
  'settings.users.rolesPermissions': 'Roles & Permissions',
  'settings.users.createRole': 'Create Role',
  'settings.users.system': 'System',
  'settings.users.noDescription': 'No description',
  'settings.users.more': 'more',
  'settings.users.pendingInvitations': 'Pending Invitations',
  'settings.users.noPendingInvitations': 'No pending invitations',
  'settings.users.editRole': 'Edit Role',
  'settings.users.createNewRole': 'Create New Role',
  'settings.users.roleDialogDesc': 'Configure role permissions for your organization',
  'settings.users.roleName': 'Role Name',
  'settings.users.roleNamePlaceholder': 'Enter role name',
  'settings.users.roleDescription': 'Description',
  'settings.users.roleDescPlaceholder': 'Enter role description',
  'settings.users.permissions': 'Permissions',
  'settings.users.updateRole': 'Update Role',
  'settings.users.invitationExists': 'Invitation Already Exists',
  'settings.users.invitationExistsDesc': 'An invitation for this email address already exists and is still pending.',
  'settings.users.close': 'Close',
  'settings.users.resending': 'Resending...',
  'settings.users.resendInvitation': 'Resend Invitation',
  'settings.users.editUserDetails': 'Edit User Details',
  'settings.users.editUserDesc': 'Update user information and role assignment',
  'settings.users.emailCannotChange': 'Email cannot be changed',
  'settings.users.phone': 'Phone',
  'settings.users.phonePlaceholder': 'Enter phone number',
  'settings.users.saveChanges': 'Save Changes',

  // Common
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.cancel': 'Cancel',
  'common.error': 'Error',
  'common.success': 'Success',

  // Settings Page Chrome
  'settings.page.title': 'Settings',
  'settings.page.subtitle': 'Manage your organization configuration and preferences',
  'settings.nav.organisation': 'Organisation',
  'settings.nav.organisationDesc': 'Company details and preferences',
  'settings.nav.usersRoles': 'Users & Roles',
  'settings.nav.usersRolesDesc': 'Manage team members and permissions',
  'settings.nav.stages': 'Stages',
  'settings.nav.stagesDesc': 'Configure lead and alteration workflows',
  'settings.nav.fittingRooms': 'Fitting Rooms',
  'settings.nav.fittingRoomsDesc': 'Manage appointment locations',
  'settings.nav.businessHours': 'Business Hours',
  'settings.nav.businessHoursDesc': 'Configure operating hours and holidays',
  'settings.nav.integrations': 'Integrations',
  'settings.nav.integrationsDesc': 'Connect external services',
  'settings.nav.templates': 'Templates',
  'settings.nav.templatesDesc': 'Email and SMS message templates',
  'settings.nav.taskTemplates': 'Task Templates',
  'settings.nav.taskTemplatesDesc': 'Automated task generation rules',
  'settings.nav.portalContent': 'Portal Content',
  'settings.nav.portalContentDesc': 'Manage FAQ and help articles',
  'settings.nav.branding': 'Portal Branding',
  'settings.nav.brandingDesc': 'Customize customer portal appearance',
  'settings.nav.portalAuth': 'Portal Authentication',
  'settings.nav.portalAuthDesc': 'Configure OTP codes and magic link settings',
  'settings.nav.leadRules': 'Lead Rules',
  'settings.nav.leadRulesDesc': 'Automated follow-up rules for leads',
  'settings.nav.notifications': 'Notifications',
  'settings.nav.notificationsDesc': 'Push and email notification settings',
  'settings.nav.translations': 'Document Translations',
  'settings.nav.translationsDesc': 'Manage PDF document translations',
  'settings.nav.billing': 'Billing',
  'settings.nav.billingDesc': 'Subscription and payment details',
  'settings.nav.customFields': 'Custom Fields',
  'settings.nav.customFieldsDesc': 'Create custom fields for leads and customers',
  'settings.nav.badgeBeta': 'Beta',
  'settings.nav.badgePwa': 'PWA',
  'settings.stripe.error': 'Error',
  'settings.stripe.connectionFailed': 'Stripe connection failed: {error}',
  'settings.stripe.success': 'Success',
  'settings.stripe.connectedSuccessfully': 'Stripe connected successfully',
  'settings.stripe.failedToComplete': 'Failed to complete Stripe connection',

  // Procurement / Purchase Orders
  'purchase_orders': 'Purchase Orders',
  'po.title': 'Purchase Orders',
  'po.subtitle': 'Manage supplier orders, receiving, and allocations',
  'po.search': 'Search PO # or supplier...',
  'po.empty': 'No purchase orders found',
  'po.notFound': 'Purchase order not found',
  'po.create.button': 'Create PO',
  'po.create.title': 'Create Purchase Order',
  'po.create.supplier': 'Supplier',
  'po.create.selectSupplier': 'Select a supplier',
  'po.create.supplierRequired': 'Please select a supplier',
  'po.create.currency': 'Currency',
  'po.create.expectedDelivery': 'Expected Delivery',
  'po.create.notes': 'Notes',
  'po.create.submit': 'Create Draft PO',
  'po.create.success': 'Purchase order created',
  'po.status.all': 'All',
  'po.status.draft': 'Draft',
  'po.status.sent': 'Sent',
  'po.status.confirmed': 'Confirmed',
  'po.status.shipped': 'Shipped',
  'po.status.partially_received': 'Receiving',
  'po.status.received': 'Received',
  'po.status.cancelled': 'Cancelled',
  'po.statusChanged': 'Status updated',
  'po.noDeliveryDate': 'No delivery date',
  'po.table.number': 'PO #',
  'po.table.supplier': 'Supplier',
  'po.table.status': 'Status',
  'po.table.expectedDelivery': 'Expected Delivery',
  'po.table.total': 'Total',
  'po.table.createdAt': 'Created',
  'po.tabs.items': 'Items',
  'po.tabs.allocations': 'Allocations',
  'po.tabs.invoice': 'Invoice',
  'po.actions.send': 'Send',
  'po.actions.confirm': 'Confirm',
  'po.actions.ship': 'Ship',
  'po.actions.cancel': 'Cancel',
  'po.items.add': 'Add Item',
  'po.items.addTitle': 'Add Line Item',
  'po.items.product': 'Product',
  'po.items.selectProduct': 'Select a product',
  'po.items.quantity': 'Quantity',
  'po.items.unitCost': 'Unit Cost',
  'po.items.ordered': 'Ordered',
  'po.items.received': 'Received',
  'po.items.lineTotal': 'Line Total',
  'po.items.empty': 'No items yet — add products to this PO',
  'po.items.added': 'Item added',
  'po.items.deleted': 'Item removed',
  'po.receive.button': 'Receive',
  'po.receive.title': 'Receive Items',
  'po.receive.ordered': 'Ordered',
  'po.receive.received': 'Received',
  'po.receive.remaining': 'Remaining',
  'po.receive.qty': 'Receive',
  'po.receive.submit': 'Confirm Receipt',
  'po.receive.noItems': 'Enter quantities to receive',
  'po.receive.success': 'Items received successfully',
  'po.allocations.add': 'Allocate',
  'po.allocations.addTitle': 'Allocate SO Line',
  'po.allocations.soLine': 'Sales Order Line',
  'po.allocations.selectSOLine': 'Select demand signal...',
  'po.allocations.qty': 'Allocated Quantity',
  'po.allocations.allocate': 'Allocate',
  'po.allocations.created': 'Allocation created',
  'po.allocations.none': 'No allocations yet',
  'po.allocations.order': 'Order',
  'po.allocations.customer': 'Customer',
  'po.allocations.allocated': 'Allocated',
  'po.allocations.fulfilled': 'Fulfilled',
  'po.allocations.risk': 'Risk',
  'po.invoice.title': 'Supplier Invoice',
  'po.invoice.ref': 'Invoice Reference',
  'po.invoice.amount': 'Invoice Amount',
  'po.invoice.date': 'Invoice Date',
  'po.invoice.fileUrl': 'File URL',
  'po.orderDetail.tab': 'Procurement',
  'po.orderDetail.title': 'Purchase Order Allocations',
  'po.orderDetail.noAllocations': 'No procurement allocations for this order yet',
  'po.supplier.noPOs': 'No purchase orders for this supplier',

  // Brands & Collections
  'settings.nav.brandsCollections': 'Brands & Collections',
  'settings.nav.brandsCollectionsDesc': 'Manage brand catalog and collection lines',
  'settings.brands.title': 'Brands & Collections',
  'settings.brands.addBrand': 'Add Brand',
  'settings.brands.addBrandDialogDesc': 'Create a new brand and then add collections from the list.',
  'settings.brands.addBrandPlaceholder': 'Enter brand name...',
  'settings.brands.addCollectionPlaceholder': 'Add collection...',
  'settings.brands.searchPlaceholder': 'Search brands or collections...',
  'settings.brands.filters.title': 'Filters',
  'settings.brands.filters.dialogDesc': 'Refine and sort your brands list.',
  'settings.brands.filters.source': 'Source',
  'settings.brands.filters.visibility': 'Visibility',
  'settings.brands.filters.sort': 'Sort',
  'settings.brands.filters.pageSize': 'Items per page',
  'settings.brands.filters.allSources': 'All sources',
  'settings.brands.filters.sharedOnly': 'Shared only',
  'settings.brands.filters.customOnly': 'Custom only',
  'settings.brands.filters.visibleOnly': 'Visible only',
  'settings.brands.filters.hiddenOnly': 'Hidden only',
  'settings.brands.filters.allVisibility': 'All visibility',
  'settings.brands.filters.clear': 'Clear filters',
  'settings.brands.filters.apply': 'Apply',
  'settings.brands.sort.nameAsc': 'Name (A-Z)',
  'settings.brands.sort.nameDesc': 'Name (Z-A)',
  'settings.brands.sort.collectionsDesc': 'Most collections',
  'settings.brands.sort.collectionsAsc': 'Least collections',
  'settings.brands.table.brand': 'Brand',
  'settings.brands.table.type': 'Type',
  'settings.brands.table.collections': 'Collections',
  'settings.brands.table.status': 'Status',
  'settings.brands.table.actions': 'Actions',
  'settings.brands.status.active': 'Active',
  'settings.brands.status.hidden': 'Hidden',
  'settings.brands.emptyFiltered': 'No brands match your current filters.',
  'settings.brands.pagination.showing': 'Showing {from}-{to} of {total}',
  'settings.brands.pagination.previous': 'Previous',
  'settings.brands.pagination.next': 'Next',
  'settings.brands.shared': 'Shared',
  'settings.brands.custom': 'Custom',
  'settings.brands.collectionsCount': 'collections',
  'settings.brands.noCollections': 'No collections yet',
  'settings.brands.noBrands': 'No brands yet. Add your first brand above.',
  'settings.brands.hiddenTitle': 'Hidden Brands',
  'settings.brands.hide': 'Hide',
  'settings.brands.unhide': 'Unhide',
  'settings.brands.collapse': 'Collapse',
  'settings.brands.expand': 'Show',
  'settings.brands.brandAdded': 'Brand added',
  'settings.brands.brandDeleted': 'Brand deleted',
  'settings.brands.collectionAdded': 'Collection added',
  'settings.brands.collectionDeleted': 'Collection deleted',
};
